/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import gsap, { Power1 } from 'gsap';
import Button from 'components/base/Button';
import Icon from 'components/icon';

const PageSwitch = ({ children, switchPage }) => {
  const [openCreatePage, setOpenCreatePage] = useState(false);
  const [isAnimationStart, setIsAnimationStart] = useState(false);

  const handleSwitchPage = () => {
    const tl = gsap.timeline();
    tl.to('.mainContainer', {
      transform: 'translateX(-500px)',
      opacity: 0,
      duration: 0.5,
      ease: Power1.easeIn
    });
    setTimeout(() => {
      setOpenCreatePage(true);
    }, 500);
  };

  const handleBack = () => {
    setIsAnimationStart(true);
    setOpenCreatePage(false);

    setTimeout(() => {
      gsap.fromTo(
        '.mainContainer',
        { opacity: 0, transform: 'translateX(-500px)' },
        {
          opacity: 1,
          transform: 'translateX(0px)',
          duration: 0.5,
          ease: 'power2.out'
        }
      );
    }, 50);
  };

  return (
    <>
      {' '}
      {!openCreatePage ? (
        <div
          style={{ opacity: isAnimationStart ? '0' : '1' }}
          className="mainContainer"
        >
          {typeof children === 'function' ? (
            <>{children(handleSwitchPage)}</>
          ) : (
            <>{children}</>
          )}
        </div>
      ) : (
        <SwitchedPage handleBack={handleBack} switchPage={switchPage} />
      )}
    </>
  );
};

const SwitchedPage = ({ handleBack = () => {}, switchPage }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    // Apply GSAP animation
    gsap.fromTo(
      elementRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        onComplete: () => {
          if (elementRef.current) {
            gsap.set(elementRef.current, {
              clearProps: 'position'
            });
          }
          // Clear specified CSS properties after animation is done
        }
      }
    );
  }, []);

  const customBack = () => {
    // gsap out animation before back
    gsap.to(elementRef.current, {
      opacity: 0,
      y: 50,
      duration: 1,
      ease: 'power2.in',
      onComplete: () => {
        handleBack();
      }
    });
  };

  return (
    <div ref={elementRef}>
      <Button
        className="p-0 d-flex align-items-center mb-2"
        variant="link"
        onClick={customBack}
      >
        <Icon icon={'icon-park-outline:left'} fontSize="18px" className="" />
        Back to list
      </Button>
      {switchPage(customBack)}
    </div>
  );
};

export default PageSwitch;
